// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export const custom = {};
//# sourceMappingURL=inspect-browser.mjs.map